import { DOC_SOURCE } from "constants/documents";
import { buildWritingEditorUrl } from "layout/proposals/outline/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal } from "slices/app/actions/modals";
import { selectOutlineOwner } from "slices/proposalOutline/selectors";

const useOpenDocumentEditor = () => {
  const dispatch = useDispatch();
  const owner = useSelector(selectOutlineOwner);
  const navigate = useNavigate();

  return (data = {}, { modalType, source, templateId }) => {
    const documentId = data?.documentId;
    const isSourceAddIn = source === DOC_SOURCE.ADDIN;

    if (!documentId) {
      return;
    }

    const url = buildWritingEditorUrl(owner, documentId);

    if (url) {
      navigate(url, {
        state: { promptAddInDownload: isSourceAddIn, templateId },
      });

      if (modalType) {
        dispatch(hideModal(modalType));
      }
    }
  };
};

export default useOpenDocumentEditor;
